// ----------------------------------------------------------------------------
// Snippet: Color Swatches
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_color-swatches.scss';

// -------------------------------------
// Initialize
// -------------------------------------
// Initiate Color Swatches
const colorSwatchSections = document.querySelectorAll('.color-swatches');
colorSwatchSections.forEach((colorSwatchSection) => {
    colorSwatchSection.querySelectorAll('.color-swatch').forEach(colorSwatch => {
        colorSwatch.addEventListener('mouseenter', event => tempChangeVariantTitle(event));
        colorSwatch.addEventListener('mouseleave', event => changeBackVariantTitle(event));
    });
});

// -------------------------------------
// Hooks
// -------------------------------------
const tempChangeVariantTitle = (event) => {
    const target = event.currentTarget;
    const newLabel = target.ariaLabel;
    const container = target.closest('.color-swatches');
    const subtitle = container.querySelector('.swatch__title .swatch__subtitle');
    subtitle.textContent = newLabel;
};

const changeBackVariantTitle = (event) => {
    const target = event.currentTarget;
    const container = target.closest('.color-swatches');
    const chosenLabelContainer = container.querySelector('.selected');
    const oldLabel = chosenLabelContainer.ariaLabel;
    const subtitle = container.querySelector('.swatch__title .swatch__subtitle');
    subtitle.textContent = oldLabel;
};

